/**
 * Example JavaScript singleton module
 */

var Gsap = (function($) {
  function initGsap() {
    gsap.registerPlugin(ScrollTrigger);
  }

  function initHeroImage() {
    gsap.fromTo(
      ".home-hero__image",
      {
        left: "120%",
        opacity: 1,
        x: 0
      },
      {
        left: "50%",
        opacity: 1,
        x: 0,
        duration: 1.4,
        ease: "power3.out",
        delay: 1
      }
    );
  }

  function init() {
    if (!$(".main").length) {
      return;
    }
    initGsap();

    if ($(".home-hero__image").length) {
      initHeroImage();
    }
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Gsap.init);
